import { render } from "./developer-options.vue?vue&type=template&id=30a9cf46"
import script from "./developer-options.vue?vue&type=script&lang=js"
export * from "./developer-options.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ns/Desktop/entwicklung/github/corpred_desk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__